import { render, staticRenderFns } from "./PassengerCard.vue?vue&type=template&id=a0046e16&scoped=true"
import script from "./PassengerCard.vue?vue&type=script&lang=js"
export * from "./PassengerCard.vue?vue&type=script&lang=js"
import style0 from "./PassengerCard.vue?vue&type=style&index=0&id=a0046e16&prod&lang=scss"
import style1 from "./PassengerCard.vue?vue&type=style&index=1&id=a0046e16&prod&lang=scss&scoped=true"
import style2 from "./PassengerCard.vue?vue&type=style&index=2&id=a0046e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0046e16",
  null
  
)

export default component.exports